<template>
  <item-animator :items="items" data-test="battleList">
    <template v-slot="item">
      <item-container :loaded="item" data-test="battleItem">
        <template v-slot:default>
          <display-field
            :primary="true"
            :value="item.name"
            @input="name => update({ id: item.id, name })"
            @destroy="destroy"
            data-test="battleItemName"
            placeholder="Enter battle name"
          />

          <router-link :to="`/battles/${item.id}`" tag="div" class="relative">
            <a class="o-obvious-button" :href="`/battles/${item.id}`">
              load<span class="max-sm:hidden"> this battle</span>
            </a>
          </router-link>
        </template>

        <template v-slot:after>
          <button
            :class="$options.$styles.delete"
            @click="() => destroy(item.id)"
            data-test="battleItemDelete"
            title="Delete battle"
            v-if="loggedIn"
          >
            ×
          </button>
        </template>
      </item-container>
    </template>
  </item-animator>
</template>

<script>
import DisplayField from './DisplayField'
import ItemAnimator from './ItemAnimator'
import ItemContainer from './ItemContainer'
import { mapActions } from 'vuex'

export default {
  name: `BattleList`,
  components: { ItemAnimator, ItemContainer, DisplayField },
  data() {
    return {
      battles: [],
    }
  },
  props: {
    loggedIn: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(`battle`, [`update`]),
    ...mapActions(`battles`, [`destroy`]),
  },
  $styles: {
    delete: `
      bg-transparent button-reset hover:bg-transparent hover:opacity-100 hover:text-accent o-button opacity-40 t text-accent py-4
    `,
  },
}
</script>
